var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMegaphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 509.287 509.287",
    style: {
      enableBackground: "new 0 0 509.287 509.287"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F8B517"
    },
    cx: 254.644,
    cy: 254.644,
    r: 254.644
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0582F"
    },
    points: "190.898,316.694 240.742,372.302 207.852,422.146 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1F3F7"
    },
    d: "M408.244,48.148c0,0-91.889,122.744-200.392,122.744v99.348 c108.503,0,200.392,122.744,200.392,122.744h19.327V48.148H408.244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0582F"
    },
    d: "M58.321,179.37c-10.511,0-18.988,8.477-18.988,18.988v44.419c0,10.511,8.477,18.988,18.988,18.988 h52.556V179.37H58.321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#646B79"
    },
    d: "M226.162,460.122l-38.993-193.611h-85.446l40.011,199.714c1.356,7.121,7.46,12.207,14.58,12.207 h54.93C220.736,478.093,227.857,469.616,226.162,460.122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0090FF"
    },
    d: "M425.875,31.195c-10.85,0-19.327,8.816-19.327,19.327V387.56c0,10.85,8.816,19.327,19.327,19.327 c10.85,0,19.327-8.816,19.327-19.327V50.522C445.203,39.672,436.387,31.195,425.875,31.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDBDBE"
    },
    d: "M198.019,146.479H84.429c-9.494,0-17.293,7.799-17.293,17.293v113.589 c0,9.494,7.799,17.293,17.293,17.293h113.589c9.494,0,17.293-7.799,17.293-17.293V163.772 C215.311,154.278,207.852,146.479,198.019,146.479z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.65e41f4a.svg";
export { ForwardRef as ReactComponent };